import Dashboard from "../Dashboard";
import AdminUserProfileComponent from "../../../features/adminDashboard/usermanagement/AdminUserProfile/AdminUserProfileComponent";

function AdminUserProfile() {
  return (
    <Dashboard>
      <AdminUserProfileComponent />
    </Dashboard>
  );
}

export default AdminUserProfile;
